import apiPaths from '../../api-paths';

export default {
    get(groupId, params = {}) {
        return axios.get(`${apiPaths.CRM}/mail-groups/${groupId}/receivers`, { params });
    },
    save(groupId, data) {
        return axios.post(`${apiPaths.CRM}/mail-groups/${groupId}/receivers`, data);
    },
    delete(groupId, data) {
        return axios.delete(`${apiPaths.CRM}/mail-groups/${groupId}/receivers`, {
            data: data
        });
    }
}